import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWorkMonth } from '../common/commonSlice';
import { EDocumentsStyled } from '../../asset/styled/EDocumentsStyled';

const WorkedMonthSection = () => {
  const dispatch = useDispatch();
  const workMonthData = useSelector(state => state.common.workMonthData);
  const [currentPage, setCurrentPage] = useState(0);
  // 터치 시작 위치를 저장할 state
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // 최소 스와이프 거리 설정 (픽셀)
  const minSwipeDistance = 50;

  const months = [
    { key: 'htm001', name: '1월' },
    { key: 'htm002', name: '2월' },
    { key: 'htm003', name: '3월' },
    { key: 'htm004', name: '4월' },
    { key: 'htm005', name: '5월' },
    { key: 'htm006', name: '6월' },
    { key: 'htm007', name: '7월' },
    { key: 'htm008', name: '8월' },
    { key: 'htm009', name: '9월' },
    { key: 'htm010', name: '10월' },
    { key: 'htm011', name: '11월' },
    { key: 'htm012', name: '12월' },
  ];
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(null);

  // 터치 이벤트 핸들러
  const onTouchStart = e => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  // 마우스 이벤트 핸들러
  const onMouseDown = e => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const onMouseMove = e => {
    if (!isDragging) return;
    setTouchEnd(e.clientX);
  };

  const onMouseUp = () => {
    if (!isDragging) return;
    handleSwipeEnd(startX, touchEnd);
    setIsDragging(false);
  };

  // 공통 스와이프 처리 로직
  const handleSwipeEnd = (start, end) => {
    if (!start || !end) return;

    const distance = start - end;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentPage < totalPages - 1) {
      setCurrentPage(prev => prev + 1);
    }
    if (isRightSwipe && currentPage > 0) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const onTouchEnd = () => {
    handleSwipeEnd(touchStart, touchEnd);
  };

  const itemsPerPage = 4;
  const totalPages = Math.ceil(months.length / itemsPerPage);

  useEffect(() => {
    dispatch(getWorkMonth());
  }, [dispatch]);

  const handlePageChange = index => {
    setCurrentPage(index);
  };

  const paginatedMonths = months.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  return (
    <EDocumentsStyled style={{ gap: '30px' }}>
      <div
        className="monthSection"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}>
        {paginatedMonths.map(month => (
          <div key={month.key} className="monthBox">
            <div className={`month ${workMonthData[month.key] != 0 ? 'work' : 'notWork'}`}>
              {month.name}
            </div>
            <div className="monthText body2Bold">
              {workMonthData[month.key] != 0 ? '일했어요' : ''}
            </div>
          </div>
        ))}
      </div>
      <div className="pagination">
        {Array.from({ length: totalPages }).map((_, index) => (
          <span
            key={index}
            className={`dot ${currentPage === index ? 'active' : ''}`}
            onClick={() => handlePageChange(index)}></span>
        ))}
      </div>
    </EDocumentsStyled>
  );
};

export default WorkedMonthSection;
